export default __webpack_public_path__ + "static/media/Emails@32.a242f42d.svg";